/* eslint-disable react-hooks/exhaustive-deps */
import { ENTERED_BY_MARKET_NAME } from '@/constants/localstorage';
import { useRegisterToken } from '@/contexts/register-token';
import { ROUTES } from '@/routes';
import { useEffect } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';

const MarketRegisterMarketName = () => {
  const params = useParams<{ marketName: string }>();
  const { setShopbyToken } = useRegisterToken();
  const navigate = useNavigate();
  const [searchParmas] = useSearchParams();

  const location = useLocation();

  const marketName = params.marketName || '';

  useEffect(() => {
    if (marketName === 'naver') {
      localStorage.setItem(ENTERED_BY_MARKET_NAME, 'naver');
      navigate(ROUTES.naverRegisterStart);
    } else if (marketName === 'shopby') {
      localStorage.setItem(ENTERED_BY_MARKET_NAME, 'shopby');
      const code = searchParmas.get('code') || '';
      setShopbyToken(code);
      navigate(ROUTES.signin);
    } else if (marketName === 'cafe24') {
      localStorage.setItem(ENTERED_BY_MARKET_NAME, 'cafe24');
      navigate(`${ROUTES.cafe24RegisterStart}${location.search}`);
    } else {
      localStorage.removeItem(ENTERED_BY_MARKET_NAME);
      navigate(ROUTES.root);
    }
  }, []);

  return null;
};

export default MarketRegisterMarketName;
